<template>
  <img
    src="/img/embbay_logo_long_plain.svg"
    alt="Long Embbay logo (early version)"
  />
</template>
